<template>
	<div class="template">
		<div class="search">
			<div>
				<span class="title">关键字：</span>
				<Input
					v-model="search.name"
					placeholder="机构名称、活动名称"
					style="width: 310px; margin-right: 10px"
					icon="ios-search"
				></Input>
				<span class="title">电话号码：</span>
				<Input v-model="search.mobile" placeholder="请输入电话号码" style="width: 200px"></Input>
				<Button style="width: 90px;margin-left:10px" type="primary" icon="ios-search" @click="searchFn">搜索</Button>
        <Button style="margin-left: 10px; width: 90px" @click="clearFn">清空</Button>
			</div>
		</div>
		<div class="table">
			<Table border :columns="diyData.columns" :data="apiData.tableList">
				<template slot="footer">
					<Page
						:total="apiData.total"
						show-total
						:page-size="apiData.per_page"
						:current="search.page"
						class-name="footer-page"
						@on-change="pageChange"
					></Page>
				</template>
			</Table>
		</div>
	</div>
</template>

<script>
	import { apiAdClickList } from '@/api/insurance'
	export default {
		name: 'insurance-ad-list',
		data() {
			return {
				query: {},
				search: {
					name: '',
					mobile: '',
					page: 1,
				},
				diyDom: {},
				diyData: {
					columns: [
						{
							title: 'ID',
							width: 120,
							render: (h, params) => {
								return h('div', params.index + 1)
							},
						},
						{
							title: '用户昵称',
							key: 'name',
							render: (h, params) => {
								return h(
									'div',
									{
										style: {
											display: 'flex',
											alignItems: 'center',
										},
									},
									[
										h('img', {
											attrs: {
												src: params.row.avatar,
											},
											style: {
												display: params.row.avatar ? 'inline' : 'none',
												width: '35px',
												height: '35px',
												marginRight: '10px',
												borderRadius: '5px',
											},
										}),
										h('span', params.row.name),
									]
								)
							},
						},
						{
							title: '电话',
							key: 'mobile',
						},
						{
							title: '机构名称',
							key: 'institution_name',
						},
						{
							title: '活动名称',
							key: 'group_title',
						},
						{
							title: '点击时间',
							key: 'created_at',
						},
					],
				},
				apiData: {
					total: 0,
					per_page: 0,
					tableList: [],
				},
			}
		},
		methods: {
			// 获取表格数据
			getTableList() {
				this.$store.commit('setSpinShow', true)
				apiAdClickList({
					...this.search,
				})
					.then(res => {
						const { data, meta } = res
						this.apiData.total = meta.pagination.total
						this.apiData.per_page = meta.pagination.per_page
						this.apiData.tableList = data
					})
					.finally(() => this.$store.commit('setSpinShow', false))
			},
			// 分页
			pageChange(e) {
				this.search.page = e
				this.getTableList()
			},
			// 搜索
			searchFn() {
				this.search.page = 1
				this.getTableList()
			},
			// 清空
			clearFn() {
				this.search = {
					name: '',
					page: 1,
					mobile: '',
				}
				this.getTableList()
			},
		},
		mounted() {
			this.getTableList()
		},
	}
</script>

<style scoped lang="less">
	.template {
		.search {
			display: flex;
			justify-content: space-between;
		}
		.table {
			margin-top: 10px;
		}
		.filter {
			margin: 10px 0;
			display: flex;
			justify-content: left;
			align-items: center;
			padding: 6px 0 20px 0;
			flex-wrap: wrap;
			border: 1px solid rgba(237, 237, 237, 1);

			.filter-item {
				margin: 14px 0 0 20px;

				.title {
					margin-right: 10px;
					font-size: 12px;
					font-weight: 400;
					color: rgba(74, 74, 74, 1);
					line-height: 17px;
				}
			}
		}
	}
</style>
